


















































import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'ImgTable',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  methods: {},
  data: function () {
    return {
      hover: false,
      modal: false,
    };
  },
});
